module.exports = __webpack_public_path__ + "static/media/customer.61bf3583.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/customer.svg
// module id = 1413
// module chunks = 0